<template>
 <div class="expert-buzz">
  <MobileNav :page_title="nav_title" />

  <!-- <span class="page-container" > -->
  <template v-if="!isMobile">
   <LivePriceTickerVue></LivePriceTickerVue>

   <!-- Left Section for Desktop View -->
   <DataCategorisationLeftSection />

   <!-- Right Section -->
   <div class="right-section">
    <div class="expert-post">
     <!-- Header of the card -->
     <div class="community-header">
      <i class="el-icon-back" @click="goBack()"></i>
      <div class="title">ExpertBuzz</div>
     </div>
     <ExpertCommunityPost :posts="communityPosts" />

     <!-- pagination -->
     <div style="text-align: center">
      <div class="show-more-tab" v-if="page_no < totalPages && !isCommunityPostsLoading" @click="loadMorePosts()">Load more</div>
     </div>

     <!-- Loader -->
     <div :class="{ 'infinite-loader-top-position': page_no == 1 }" v-if="isCommunityPostsLoading">
      <div class="text-center">
       <img src="../assets/images/company/loader.svg" style="height: 80px; width: 80px" />
      </div>
     </div>
     <!-- No data -->
     <div v-if="communityPostsLoaded && !isCommunityPostsLoading && !communityPosts.length">
      <NoDataFound></NoDataFound>
     </div>
    </div>
    <div class="right-side-column">
     <CommunityLatestRecommendation :recommendations="latestRecos" :isRecoListLoading="isRecoListLoading" @get_reco_details="recoDetails" />
     <ChatExpertCommunity :experts="experts_list" />
    </div>
   </div>
  </template>

  <template v-else>
   <LivePriceTickerVue></LivePriceTickerVue>

   <div class="chat-expert-list">
    <div class="list-inner-section">
     <div class="cards" v-for="expert in experts_list" @click="$router.push('/expert-list')">
      <img v-if="expert.profileImage" :src="expert.profileImage" alt="" width="40px" />
      <img v-else src="../assets/images/navBar/avatar.jpg" alt="" width="40px" />
      <button class="chat-btn">Chat</button>
     </div>

     <div class="explore-section" @click="$router.push('/expert-list')">
      <i class="el-icon-right"></i>
      <div>Explore</div>
     </div>
    </div>
   </div>

   <div class="right-section">
    <div class="expert-post">
     <!-- Header of the card -->
     <div class="community-header">
      <i class="el-icon-back" @click="goBack()"></i>
      <div class="title">ExpertBuzz</div>
     </div>

     <ExpertCommunityPost :posts="communityPosts" />
     <!-- pagination -->
     <div style="text-align: center">
      <div class="show-more-tab" v-if="page_no < totalPages && !isCommunityPostsLoading" @click="loadMorePosts()">Load more</div>
     </div>
     <!-- Loader -->
     <div :class="{ 'infinite-loader-top-position': page_no == 1 }" v-if="isCommunityPostsLoading">
      <div class="text-center">
       <img src="../assets/images/company/loader.svg" style="height: 80px; width: 80px" />
      </div>
     </div>

     <div v-if="communityPostsLoaded && !isCommunityPostsLoading && !communityPosts.length">
      <NoDataFound></NoDataFound>
     </div>
    </div>
    <div class="right-side-column">
     <CommunityLatestRecommendation :recommendations="latestRecos" :isRecoListLoading="isRecoListLoading" @get_reco_details="recoDetails" />
     <ChatExpertCommunity :experts="experts_list" />
    </div>
   </div>
  </template>

  <StockDialog v-if="isStockDetailsDialogVisible" :isStockDetailsDialogVisible.sync="isStockDetailsDialogVisible" :reco_data="reco_data" />

  <!-- Fixed YouTube Card -->
  <el-card shadow="always" class="youtube-card-fixed" v-if="youtube_video_link.length && is_video_visible">
   <i class="el-icon-circle-close" @click="is_video_visible = false" style="cursor: pointer; position: absolute; top: -2px; font-size: 25px; color: #ffffff; right: -1px"></i>
   <iframe :src="youtube_video_link" title="YouTube video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </el-card>
 </div>
</template>

<script>
import LivePriceTickerVue from '../components/LivePriceTicker.vue';
import MobileNav from '@/components/MobileNav.vue';
import DataCategorisationLeftSection from '@/components/DataCategorisationLeftSection.vue';
import DataCategorisationCarousel from '@/components/DataCategorisationCarousel.vue';
import { screenSize } from '../mixins/ScreenSize.js';
import { serverAddr, serverHostName } from '../networkConfig';
import NewsSectionComponent from '@/components/NewsSectionComponent.vue';
import NewsPopupComponent from '@/components/NewsPopupComponent.vue';
import ExpertCommunityPost from '@/components/ExpertCommunityPost.vue';
import moment from 'moment';
import { HelperNetworkCallBack } from '../mixins/Helper';
import ChatExpertCommunity from '@/components/ChatExpertCommunity.vue';
import CommunityLatestRecommendation from '@/components/CommunityLatestRecommendation.vue';
import StockDialog from '@/components/StockDialog.vue';
import { updateProfileNetworkCallBack } from '../mixins/UpdateProfile.NetworkCallBack';
import Trade from '@/components/Trade.vue';
import NoDataFound from '@/components/NoDataFound.vue';

export default {
 name: 'ExpertBuzz',
 mixins: [screenSize, HelperNetworkCallBack, updateProfileNetworkCallBack],
 components: {
  MobileNav,
  DataCategorisationLeftSection,
  DataCategorisationCarousel,
  NewsSectionComponent,
  NewsPopupComponent,
  LivePriceTickerVue,
  ExpertCommunityPost,
  ChatExpertCommunity,
  CommunityLatestRecommendation,
  StockDialog,
  Trade,
  NoDataFound,
 },

 data() {
  return {
   nav_title: 'Expert Buzz',
   serverHostName: serverHostName,
   isMobile: false,
   userProfile: {},
   planSubscriptionStatusDetails: null,
   isNewsPopupVisible: false,
   selectedNews: null,
   websiteUserType: {},
   latestRecos: [],
   isRecoListLoading: false,
   isStockDetailsDialogVisible: false,
   reco_data: {},
   isExpertListLoading: false,
   isCommunityPostsLoading: false,
   experts_list: [],
   communityPosts: [],
   page_no: 1,
   totalPages: null,
   youtube_video_link: '',
   is_video_visible: true,
   communityPostsLoaded: false,
  };
 },

 created() {
  if (!localStorage.getItem('currentEnvironment')) {
   this.selectUserType();
  }
  this.userProfile = JSON.parse(localStorage.getItem('profile'));
 },

 mounted() {
  // Call getUserProfile initially
  // this.getUserProfile();

  // select user type for navigation access
  if (localStorage.getItem('websiteUserType')) {
   this.websiteUserType = JSON.parse(localStorage.getItem('websiteUserType'));

   this.fetchAllData();
  }

  this.checkScreenSize();
  window.addEventListener('resize', this.checkScreenSize);
 },

 methods: {
  goBack() {
   if (this.$route.query.post_id) {
    this.removeQueryParam();
   } else {
    this.$router.push('/experts-past-recommendations');
   }
  },
  removeQueryParam() {
   // Access the current query parameters
   let queryParams = { ...this.$route.query };

   // Remove a specific query parameter (e.g., 'example')
   delete queryParams.post_id;

   this.$router.push({ query: queryParams });

   this.communityPosts = [];
   this.page_no = 0;
   this.totalPages = null;

   //  Get all Community Posts
   this.loadMorePosts();
  },
  async loadMorePosts() {
   if (this.totalPages && this.page_no >= this.totalPages) return; // Prevent extra calls

   this.page_no += 1;
   const response = await this.getAllCommunityPosts(this.page_no);
   if (response && response.data && response.data.status) {
    this.communityPosts = [...this.communityPosts, ...response.data.data];

    console.log(this.communityPosts);
   }
  },
  showNewsPopup(news) {
   this.selectedNews = news;
   this.isNewsPopupVisible = true;
  },

  formatDate(date) {
   return moment(date).format('MMM DD, YYYY hh:mm A');
  },

  checkScreenSize() {
   this.isMobile = window.innerWidth <= 1280;
  },

  formatDate(date) {
   return moment(date).format('MMM DD, YYYY hh:mm A');
  },

  recoDetails(reco, action) {
   var reco_id = reco.id;

   serverAddr
    .post('recommendation/v1/read_recommendation', { id: reco_id })
    .then((response) => {
     if (response.data && response.data.status) {
      let data = response.data.data;

      this.reco_data = data[0];

      if (action == 'recoPopup') {
       if (this.reco_data.brokerage_data && this.reco_data.brokerage_data.IntraDay) {
        this.reco_data.brokerage_list_type = 'IntraDay';
        this.$set(this.reco_data, 'selected_brokerage_list', this.reco_data.brokerage_data.IntraDay[0].data);
        this.$set(this.reco_data, 'brokerage_list_type', 'IntraDay');
        this.$set(this.reco_data, 'reco_quantity', 1);
        this.$set(this.reco_data, 'logic_description', this.reco_data.report.length ? this.reco_data.report[0].description : '');

        if (this.reco_data.brokerage_data.IntraDay[0].exp_tax) {
         this.$set(this.reco_data, 'exp_tax', this.reco_data.brokerage_data.IntraDay[0].exp_tax);
        } else {
         this.$set(this.reco_data, 'exp_tax', this.reco_data.brokerage_data.IntraDay[0].data.total_tax_and_charges);
        }
       }
       // Open StockDialog with the filtered reco_data
       this.isStockDetailsDialogVisible = true;
      } else {
       this.openTradePopup(this.reco_data);
      }
     } else {
      console.error('Failed to fetch recommendation details:', response.data.message);
     }
    })
    .catch((error) => {
     console.error('API Error:', error);
    })
    .finally(() => {
     this.isRecoListLoading = false;
    });
  },
  openTradePopup(stockDetails) {
   var stockData = {};
   stockData.segment = 'equity';
   stockData.symbol = stockDetails.stock.symbol;
   stockData.stock_id = stockDetails.stock.id;
   stockData.stop_loss = stockDetails.stop_loss;
   stockData.target_price = stockDetails.target_price;
   stockData.order_type = stockDetails.reco;
   stockData.entry_price = stockDetails.reco_open_price;
   stockData.ltp = stockDetails.stock.current_price;
   stockData.duration = stockDetails.duration;

   if (this.isTradeVisible()) {
    if (stockDetails.reco == 'Buy') {
     // set parameters for pre selected stock in trade button
     this.$store.commit('commitTradeMenu', 'TRADE');
     this.$store.commit('commitSelectedOrder', stockData);
     this.$store.commit('tradePopupAction', true);
     this.isDataChanged = true;
    } else if (stockDetails.reco == 'Sell') {
     this.isVisibleSellNotAllowedPopup = true;
    }
   } else {
    if (this.websiteUserType.userType != 'broker') {
     this.$store.commit('commitBrokerLoginDialogVisibility', true);
     this.$store.commit('commitSelectedOrder', stockData);
    } else {
     this.$store.commit('commitSubscribPlanDialogVisibility', true);
    }
   }
  },

  handleClose() {
   this.isDataChanged = false;
   this.$store.commit('tradePopupAction', false);
  },

  getUserProfile() {
   this.is_profile_save_loading = true;

   serverAddr
    .get('/auth/v1/profile')
    .then(this.getProfileCallBack)
    .catch(function (error) {
     console.log(error);
    });
  },

  async fetchAllData() {
   this.isRecoListLoading = true;

   try {
    const [latestRecommendation, chatExpertList, communityPosts] = await Promise.allSettled([
     this.getLatestRecommendation(),
     this.getExpertList(),
     this.getAllCommunityPosts(this.page_no),
     // ...other API calls if needed
    ]);

    if (latestRecommendation.status === 'fulfilled') {
     var data = latestRecommendation.value.data;
     if (data.status) {
      this.latestRecos = data.data.map((item) => ({
       reco: item.reco,
       created_at: item.created_at,
       remaining_potential: item.remaining_potential,
       stock_name: item.stock_name,
       user_detail: item.user_detail,
       risk_tag: item.risk_tag,
       stock_logo: item.stock_logo,
       id: item.id,
      }));
     }
    } else {
     console.error('Failed to fetch latest recommendations:', latestRecommendation.reason);
    }

    if (communityPosts.status === 'fulfilled') {
     const data = communityPosts.value.data;
     // Only replace existing posts on first page
     if (this.page_no === 1) {
      this.communityPosts = data.data;
     } else {
      this.communityPosts = [...this.communityPosts, ...data.data];
     }

     this.totalPages = data.pagination.total_pages || null; // if your API sends total pages
    } else {
     console.error('Failed to fetch community posts:', communityPosts.reason);
    }

    this.communityPostsLoaded = true;

    // Handle `Chatchat_Expert_List`
    if (chatExpertList.status === 'fulfilled') {
     var data = chatExpertList.value.data;
     if (data.status) {
      this.experts_list = data.data.slice(0, 4).map((item) => ({
       expertId: item.id,
       fullName: item.full_name,
       profileImage: item.picture ? `${this.serverHostName}${item.picture}` : require('../assets/images/navBar/avatar.jpg'), // Fallback image
       verifyIcon: require('../assets/images/verify.svg'),
       status: 'offline',
       expertSkills: item.expert_skills ? item.expert_skills : '',
       sebiNumber: item.sebi_register_number ? item.sebi_register_number : '',
      }));
     }
    } else {
     console.error('Failed to fetch MTF approved stocks:', chatExpertList.reason);
    }
   } catch (error) {
    console.error('Error in fetchAllData:', error);
   } finally {
    this.isRecoListLoading = false;
   }
  },

  async getLatestRecommendation() {
   return serverAddr
    .get('/recommendation/v1/latest_recommendation')
    .then((response) => {
     return response;
    })
    .catch(
     function (error) {
      console.log(error);
     }.bind(this)
    );
  },
  async getAllCommunityPosts(page = 1) {
   this.isCommunityPostsLoading = true;
   var communityPostId = null;
   var apiUrl = '';

   console.log(this.$route.query);

   if (this.$route.query.post_id) {
    communityPostId = this.$route.query.post_id;
   }

   if (communityPostId != null && communityPostId.length) {
    apiUrl = `/community/community-post?page_number=${page}&page_per_entries=5&id=${communityPostId}`;
   } else {
    apiUrl = `/community/community-post?page_number=${page}&page_per_entries=5`;
   }

   try {
    const response = await serverAddr.get(apiUrl);
    return response;
   } catch (error) {
    console.error('Error fetching community posts:', error);
    return null;
   } finally{
    this.isCommunityPostsLoading = false;
   }
  },

  getExpertList() {
  
   return serverAddr
    .get('/user/admin/chat_expert_list')
    .then((response) => {
     return response;
    })
    .catch((error) => {
     console.log(error);
    })
    .finally(() => {
    });
  },
 },

 beforeDestroy() {
  window.removeEventListener('resize', this.checkScreenSize);
 },

 computed: {
  planDetails() {
   return JSON.parse(localStorage.getItem('plan_details'));
  },

  showTradeDialogue() {
   this.isDataChanged = this.$store.state.tradeDialogVisible ? true : false;
   return this.$store.state.tradeDialogVisible;
  },
 },
};
</script>

<style lang="scss" scoped>
.expert-buzz {
 background-color: #f4f4f4;
 //  display: flex;
 min-height: 100vh;
 overflow-x: hidden;

 .community-header {
  display: flex;
  margin: 0px 0 10px;
  padding: 0 10px;

  .el-icon-back {
   font-size: 20px;
   cursor: pointer;
   color: #333;
   transition: color 0.2s;
   font-weight: 700;
  }
  .title {
   font-size: 15px;
   font-weight: 600;
   margin-left: 10px;
  }
 }

 .chat-expert-list {
  display: none;
  margin-top: 120px;

  .list-inner-section {
   display: flex;
   align-items: start;
   justify-content: center;
   gap: 20px;

   .cards {
    display: flex;
    flex-direction: column;
    align-items: center;

    .chat-btn {
     position: relative;
     bottom: 9px;
     font-size: 9px;
     font-weight: 600;
     background: linear-gradient(180deg, #2d2e8d 0%, #2488ff 100%);
     border: none;
     border-radius: 4px;
     color: #ffff;
     padding: 5px 10px;
    }
   }

   .explore-section,
   img {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    border: 1px solid #bfbfbf;
    cursor: pointer;
   }

   .explore-section {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid black;
    font-size: 10px;
    flex-direction: column;
    font-weight: 600;

    i {
     font-size: 22px;
     margin-bottom: 2px;
     font-weight: 800;
    }
   }
  }
 }

 .DataCategorisationLeftSection {
  width: 350px;
  position: fixed;
  height: calc(100% - 80px);
  overflow-y: scroll;
  margin-top: 105px;
  padding: 20px;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
   display: none;
  }
 }

 .right-section {
  margin-left: 370px;
  padding: 20px;
  margin-top: 105px;
  color: black;
  // width: calc(100% - 410px);
  display: flex;
  // flex-direction: row; // Split horizontally
  gap: 20px;

  .expert-post {
   width: 60%;
  }

  .right-side-column {
   width: 40%;
   display: flex;
   flex-direction: column;
   gap: 20px;
  }
 }

 .responsive-col {
  @media (max-width: 1050px) {
   &:nth-child(odd),
   &:nth-child(even) {
    width: 100%;
    margin-bottom: 20px;
   }
  }
 }

 @media (max-width: 1280px) {
  padding-bottom: 70px;
  // display: block;
  .right-section {
   width: 96%;
   margin: 120px auto 0;
   padding: 0;
   padding-bottom: 70px;
  }
 }

 @media (max-width: 768px) {
  .right-section {
   margin-bottom: 0px;
   flex-direction: column;
   margin-top: 10px;

   .expert-post {
    width: 100%;
   }
   .right-side-column {
    display: none;
   }
  }

  .component-container {
   width: 95%;
   margin: 0 auto;
  }

  .chat-expert-list {
   display: block;
  }
 }

 @media (max-width: 768px) {
  .chat-expert-list {
   .list-inner-section {
    .cards .chat-btn {
     bottom: 6px;
     font-size: 8px;
     padding: 3px 6px;
    }

    .explore-section,
    img {
     width: 40px;
     height: 40px;
    }

    .explore-section {
     font-size: 8px;

     i {
      font-size: 14px;
      margin-bottom: 0px;
      font-weight: 800;
     }
    }
   }
  }
 }

 .scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  height: auto;

  &::-webkit-scrollbar {
   height: 8px;
   background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
   background-color: rgba(0, 0, 0, 0.2);
   border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
   background-color: rgba(0, 0, 0, 0.5);
  }
 }

 .el-loading-mask {
  .el-loading-spinner {
   top: 40vh;
  }
 }
}

.youtube-card-fixed {
 position: fixed;
 right: 20px;
 width: 270px;
 bottom: 20px;
 z-index: 999;
 border-radius: 12px;
 box-shadow: 0 10px 24px rgba(0, 0, 0, 0.25);

 iframe {
  width: 100%;
  height: 160px;
  border: none;
  border-radius: 12px;
 }
 .el-icon-circle-close {
  display: none;
 }
}
@media (max-width: 1280px) {
 .youtube-card-fixed {
  bottom: 70px;
 }
}
@media (max-width: 768px) {
 .youtube-card-fixed {
  .el-icon-circle-close {
   display: unset;
  }
  width: 270px;
  iframe {
   height: 160px;
  }
 }
}
</style>

<style lang="scss">
.expert-buzz {
 .sentiment-card-dialog {
  .tab-market-sentiment {
   .stock-details {
    margin: 15px;
   }

   .sentiment-options {
    display: none;
   }

   .el-card__body,
   .el-main {
    padding: 0;
   }

   .box-card {
    margin: 0;
   }
  }

  .el-dialog {
   margin-top: 100px;
   width: 550px;
   border-radius: 8px;
  }

  .el-dialog__body,
  .el-dialog__header {
   padding: 0px;
  }

  .el-dialog__headerbtn .el-dialog__close {
   z-index: 2;
   position: relative;
  }

  .box-card {
   border-radius: 10px !important;
   border: none;
   box-shadow: none;
  }

  .box-card-two {
   margin: 5px;
  }

  .employee-select-box .el-input--mini .el-input__inner {
   height: 25px;
   border-radius: 8px;
   text-transform: capitalize;
  }

  .el-progress-bar {
   padding: 0;
  }

  .el-progress__text {
   display: none;
  }

  .vuejs-countdown .digit {
   font-size: 28px;
  }

  .el-checkbox__inner {
   border-radius: 4px;
  }
 }

 @media (max-width: 768px) {
  .component-container .header {
   font-size: 13px;
   font-weight: 600;
   .view-all {
    font-size: 12px;
   }
  }
 }

 @media screen and (max-width: 600px) {
  .sentiment-card-dialog {
   .el-dialog {
    margin-top: 20px;
    width: 95%;
   }
  }
 }
}
.youtube-card-fixed {
 .el-card__body,
 .el-main {
  padding: 0px;
 }
}
</style>